import { Box, Flex, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import { CategoryFileList } from '@eapproval/ui'

import useUserManual from '../useUserManual'
import useUserManualFileActions from '../useUserManualFileActions'
import { UserManualType } from '../userManual.enum'

const UserManualViewPage = () => {
  const { useFetchUserManualByType } = useUserManual()
  const { data: userManual } = useFetchUserManualByType(UserManualType.INTERNAL)
  const { handleView, handleDownload } = useUserManualFileActions()

  const categories = userManual?.categories ?? []

  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="300px" p="5">
      <Flex p={5} mb="3">
        <Heading>User Manual</Heading>
      </Flex>
      <VStack align="stretch" spacing={4} p={5}>
        {categories.length === 0 && <Text>No user manual has been uploaded yet.</Text>}
        {categories.map((category) => (
          <Box key={category._id} borderWidth="1px" borderRadius="md" p={3}>
            <HStack align="center" spacing={4}>
              <Heading size="sm" whiteSpace="nowrap">
                {category.name}
              </Heading>
              <Box flex="1">
                <CategoryFileList
                  files={category.files ?? []}
                  editable={false}
                  title={category.name}
                  onView={handleView}
                  onDownload={handleDownload}
                />
              </Box>
            </HStack>
          </Box>
        ))}
      </VStack>
    </Box>
  )
}

export default UserManualViewPage
